import makeStyles from '@mui/styles/makeStyles';

import { pprBorderColorA } from "../../DashStyleGuides";

export const useStyles = makeStyles(() => ({
  paper: {
    border: `1px solid ${pprBorderColorA}`,
    borderRadius: 12,
    height: 400,
  },
}));
